/**
 * Recurso de tradução para LanguageSwitcher
 */

import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { languageSwitcherTranslationRef } from './languageSwitcher';

export const languageSwitcherTranslations = createTranslationResource({
  ref: languageSwitcherTranslationRef,
  translations: {
    'pt-BR': () => import('./languageSwitcher-pt-BR'),
  },
});
